import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldConfig } from '../field-interface';
import { UntypedFormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../directive/date';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class DateComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  
   field: FieldConfig['eavAttribute'];
   group: UntypedFormGroup;


  ngOnInit() {

  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    constructor(private router: Router) {
        this.url = this.router.url || '';
            this.router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this.router.url || ''; });
    }
}
